(() => {
  const glyphs = { wood: '木', fire: '火', earth: '土', metal: '金', water: '水' };
  function initialiseQuiz(root) {
    if (root.dataset.teaReady) return;
    const source = root.querySelector('[data-tea-quiz-data]');
    if (!source) return;
    let data;
    try { data = JSON.parse(source.textContent); } catch { return; }
    root.dataset.teaReady = 'true';
    const form = root.querySelector('[data-tea-quiz-form]');
    const question = root.querySelector('[data-tea-quiz-question]');
    const options = root.querySelector('[data-tea-quiz-options]');
    const next = root.querySelector('[data-tea-quiz-next]');
    const back = root.querySelector('[data-tea-quiz-back]');
    const result = root.querySelector('[data-tea-quiz-result]');
    const live = root.querySelector('[data-tea-quiz-live]');
    const box = root.querySelector('.tea-quiz-box');
    const inputName = options.querySelector('input').name;
    let step = 0;
    let answers = [];
    function render(focus = false) {
      const item = data.questions[step];
      form.hidden = false;
      result.hidden = true;
      question.textContent = item.title;
      root.querySelector('[data-tea-quiz-count]').textContent = `${String(step + 1).padStart(2, '0')} / 04`;
      root.querySelector('[data-tea-quiz-bar]').style.width = `${(step + 1) * 25}%`;
      const fragment = document.createDocumentFragment();
      item.options.forEach(itemOption => {
        const label = document.createElement('label');
        label.className = 'tea-quiz-choice';
        const input = document.createElement('input');
        input.type = 'radio';
        input.name = inputName;
        input.value = itemOption.value;
        input.checked = answers[step] === itemOption.value;
        const text = document.createElement('span');
        text.textContent = itemOption.label;
        label.append(input, text);
        fragment.append(label);
      });
      options.replaceChildren(fragment);
      next.replaceChildren(document.createTextNode(step === 3 ? data.finish : data.next));
      const arrow = document.createElement('span');
      arrow.textContent = '→';
      arrow.setAttribute('aria-hidden', 'true');
      next.append(arrow);
      next.disabled = !answers[step];
      back.disabled = step === 0;
      if (focus) {
        box.scrollIntoView({ block: 'start', behavior: 'auto' });
        question.focus({ preventScroll: true });
      }
    }
    options.addEventListener('change', event => {
      if (event.target instanceof HTMLInputElement && event.target.type === 'radio') {
        answers[step] = event.target.value;
        next.disabled = false;
      }
    });
    back.addEventListener('click', () => {
      if (step === 0) return;
      step -= 1;
      render(true);
    });
    form.addEventListener('submit', event => {
      event.preventDefault();
      if (!answers[step]) return;
      if (step < 3) {
        step += 1;
        render(true);
        live.textContent = data.questions[step].title;
        return;
      }
      const score = { wood: 0, fire: 0, earth: 0, metal: 0, water: 0 };
      answers.forEach(answer => { if (answer in score) score[answer] += 1; });
      const maximum = Math.max(...Object.values(score));
      const candidates = Object.keys(score).filter(key => score[key] === maximum);
      const winner = candidates.includes(answers[2]) ? answers[2] : answers.find(answer => candidates.includes(answer));
      const match = data.results[winner];
      root.querySelectorAll('[data-tea-result-products]').forEach(group => { group.hidden = group.dataset.teaResultProducts !== winner; });
      root.querySelector('[data-tea-result-glyph]').textContent = glyphs[winner];
      root.querySelector('[data-tea-result-name]').textContent = match.name;
      root.querySelector('[data-tea-result-note]').textContent = match.note;
      const link = root.querySelector('[data-tea-result-link]');
      link.href = match.url;
      link.textContent = match.cta;
      form.hidden = true;
      result.hidden = false;
      box.scrollIntoView({ block: 'start', behavior: 'auto' });
      result.focus({ preventScroll: true });
      live.textContent = match.name;
    });
    root.querySelector('[data-tea-quiz-restart]').addEventListener('click', () => {
      step = 0;
      answers = [];
      live.textContent = '';
      render(true);
    });
    render();
  }
  function initialiseReading(root) {
    if (root.dataset.teaReady) return;
    root.dataset.teaReady = 'true';
    const body = root.querySelector('.tea-page-body');
    const toc = root.querySelector('[data-tea-toc]');
    if (!body || !toc) return;
    let headings = Array.from(body.querySelectorAll('.tea-depth-text > h2, .tea-chapter-copy > h2'));
    if (headings.length < 2) headings = Array.from(body.querySelectorAll('.ttp-page-copy > details > summary'));
    if (headings.length < 2) return;
    const fragment = document.createDocumentFragment();
    headings.forEach((heading, index) => {
      const section = heading.closest('section,details');
      const id = section.id || `tea-note-${index + 1}`;
      section.id = id;
      const link = document.createElement('a');
      link.href = `#${id}`;
      link.textContent = heading.textContent;
      fragment.append(link);
    });
    toc.replaceChildren(fragment);
    toc.addEventListener('click', event => {
      const link = event.target.closest('a');
      if (!link) return;
      const section = document.getElementById(link.hash.slice(1));
      if (section instanceof HTMLDetailsElement) section.open = true;
    });
    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver(entries => {
        entries.filter(entry => entry.isIntersecting).forEach(entry => {
          toc.querySelectorAll('a').forEach(link => {
            if (link.hash === `#${entry.target.id}`) link.setAttribute('aria-current', 'location');
            else link.removeAttribute('aria-current');
          });
        });
      }, { rootMargin: '-15% 0px -55% 0px' });
      headings.forEach(heading => observer.observe(heading.closest('section,details')));
    }
  }
  function initialise(scope = document) {
    scope.querySelectorAll('[data-tea-quiz]').forEach(initialiseQuiz);
    scope.querySelectorAll('[data-tea-editorial]').forEach(initialiseReading);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialise(), { once: true });
  else initialise();
  document.addEventListener('shopify:section:load', event => initialise(event.target));
})();
